import { render, staticRenderFns } from "./ProductRestockDeductInput.vue?vue&type=template&id=c1e2327e&"
import script from "./ProductRestockDeductInput.vue?vue&type=script&lang=ts&"
export * from "./ProductRestockDeductInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports